var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1723 8.49513C25.5628 8.10461 25.5628 7.47144 25.1723 7.08092L18.8084 0.716958C18.4178 0.326434 17.7847 0.326434 17.3941 0.716958C17.0036 1.10748 17.0036 1.74065 17.3941 2.13117L23.051 7.78803L17.3941 13.4449C17.0036 13.8354 17.0036 14.4686 17.3941 14.8591C17.7847 15.2496 18.4178 15.2496 18.8084 14.8591L25.1723 8.49513ZM0.839111 8.78802L24.4652 8.78803L24.4652 6.78803L0.839111 6.78802L0.839111 8.78802Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.482bc4f0d520d7a2524502e563b12445.svg";
export { ForwardRef as ReactComponent };